// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4S0qd","colBig":"styles_colBig__KkYZ0","colSmall":"styles_colSmall__3Turw"};